import { render } from "./AdminIncidents.vue?vue&type=template&id=81724108&scoped=true"
import script from "./AdminIncidents.vue?vue&type=script&lang=js"
export * from "./AdminIncidents.vue?vue&type=script&lang=js"

import "./AdminIncidents.vue?vue&type=style&index=0&id=81724108&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81724108"]])

export default __exports__